
export enum OperatorType {
  Dealer= 'Dealer',
  PeopleTransportOperator= 'PeopleTransportOperator',
  Scrapyard= 'Scrapyard',
  PublicAdministration= 'PublicAdministration',
  Other= 'Other',

}